module.exports = __webpack_public_path__ + "img/cs-photo.b0d014f5.jpg";